var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 38
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__a",
    x1: 288.438,
    x2: 261.149,
    y1: 841.335,
    y2: 798.608,
    transform: "translate(0 -580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__b",
    x1: 284.13,
    x2: 244.246,
    y1: 840.76,
    y2: 762.804,
    transform: "translate(0 -580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D05B2E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.13 6.991h37.73v24.02H6.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F48120",
    d: "M43.73 20.352s-10.31 7.27-29.19 10.53h29.19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M43.86 6.851H6v24.3h38V6.841h-.14zm-.13.27v23.75H6.28V7.121z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M9.32 14.281H7.75v5.5h1.57c.83 0 1.43-.2 1.96-.63.63-.52 1-1.3 1-2.11-.01-1.63-1.22-2.76-2.96-2.76m1.26 4.14c-.34.3-.77.44-1.47.44h-.29v-3.64h.29c.69 0 1.11.12 1.47.44.371.33.59.84.59 1.37s-.22 1.06-.59 1.39M12.77 14.281h1.07v5.5h-1.07zM16.46 16.391c-.64-.24-.83-.4-.83-.69 0-.35.34-.61.8-.61.32 0 .59.13.86.45l.56-.73c-.46-.4-1.01-.61-1.62-.61-.97 0-1.72.68-1.72 1.58 0 .76.351 1.149 1.35 1.51.42.15.63.25.74.31.21.14.32.34.32.57 0 .45-.35.78-.83.78-.51 0-.92-.26-1.169-.73l-.69.67c.49.73 1.09 1.05 1.9 1.05 1.11 0 1.9-.74 1.9-1.81.02-.89-.351-1.29-1.571-1.74M18.38 17.041c0 1.62 1.27 2.87 2.9 2.87.46 0 .86-.09 1.34-.32v-1.26c-.43.43-.81.6-1.29.6-1.08 0-1.851-.78-1.851-1.9 0-1.06.79-1.89 1.8-1.89.51 0 .9.18 1.34.62V14.5c-.47-.24-.86-.34-1.321-.34-1.608 0-2.918 1.28-2.918 2.88M31.14 17.981l-1.47-3.7H28.5l2.33 5.64h.58l2.37-5.64h-1.16zM34.27 19.782h3.04v-.93h-1.97v-1.48h1.9v-.931h-1.9v-1.22h1.97v-.94h-3.04zM41.56 15.911c0-1.03-.71-1.62-1.95-1.62h-1.59v5.5h1.07v-2.21h.14l1.48 2.21h1.321l-1.73-2.32c.809-.17 1.259-.72 1.259-1.56m-2.16.91h-.31v-1.67h.33c.67 0 1.03.28 1.03.82 0 .55-.36.85-1.05.85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_svg__a)",
    d: "M307.74 229.74q0 16.353-11.563 27.917-11.565 11.563-27.917 11.563t-27.917-11.563q-11.563-11.564-11.563-27.917t11.563-27.917 27.917-11.563 27.917 11.563q11.563 11.565 11.563 27.917 0 .69-.024 1.378",
    transform: "matrix(.07422 0 0 .07422 6 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_svg__b)",
    d: "M307.74 229.74q0 16.353-11.563 27.917-11.565 11.563-27.917 11.563t-27.917-11.563q-11.563-11.564-11.563-27.917t11.563-27.917 27.917-11.563 27.917 11.563q11.563 11.565 11.563 27.917 0 .69-.024 1.378",
    transform: "matrix(.07422 0 0 .07422 6 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24 14.491c0-.1-.07-.15-.18-.15h-.16v.48h.12v-.19l.14.19h.14l-.16-.2c.06-.01.1-.06.1-.13m-.2.07h-.02v-.13h.02q.09 0 .09.06c0 .05-.03.07-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.08 14.16c-.23 0-.42.19-.42.421s.19.42.42.42.42-.19.42-.42-.19-.42-.42-.42m0 .771c-.18 0-.34-.15-.34-.35 0-.19.15-.35.34-.35.18 0 .33.16.33.35s-.15.35-.33.35"
  }))));
};
export default SvgDiscover;